import { render } from "./Slider.vue?vue&type=template&id=814ac3b6&scoped=true&ts=true"
import script from "./Slider.vue?vue&type=script&lang=ts"
export * from "./Slider.vue?vue&type=script&lang=ts"

import "./Slider.vue?vue&type=style&index=0&id=814ac3b6&scoped=true&lang=scss"
import "./Slider.vue?vue&type=style&index=1&id=814ac3b6&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-814ac3b6"]])

export default __exports__